import {Stack, styled} from '@mui/material';
import {StyledStackProps} from './types';

const StyledStack = styled(Stack)<StyledStackProps>`
	gap: 8px;
	position: fixed;
	bottom: 56px;
	left: 0;
	right: 0;
	background-color: ${({theme}) => theme.palette.background.paper};
	padding: 8px 16px;
	z-index: 1;
	border-top: 1px solid ${({theme}) => theme.palette.other.outlineBorder};

	${({theme, $isTablet}) => theme.breakpoints.up($isTablet ? 'md' : 'sm')} {
		position: initial;
		padding: initial;
		background-color: initial;
		gap: 16px;
		border-top: none;
	}
`;

export {StyledStack};
